import constants from 'constants/index'

const trimOverride = (getOverride) => (field) =>
  (getOverride(field) || '').trim()

export const getBannerLevel2Overrides = (getRawOverride) => {
  if (!getRawOverride) return {}
  const getOverride = trimOverride(getRawOverride)
  const { TEXT_FIELDS_LEVEL_2 } = constants.cookies.bannerTextOverride
  return {
    title: getOverride(TEXT_FIELDS_LEVEL_2.BANNER_LEVEL_2_TITLE),
    buttons: {
      confirm: getOverride(TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_CONFIRM),
      reject: getOverride(TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_REJECT),
      accept: getOverride(TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_ACCEPT_ALL),
    },
    sections: {
      privacyPortal: {
        title: getOverride(TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_PORTAL_LINK),
        description: getOverride(
          TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_DESCRIPTION,
        ),
      },
    },
  }
}

export const getBannerOverrides = (getRawOverride) => {
  if (!getRawOverride) return {}
  const getOverride = trimOverride(getRawOverride)
  const { TEXT_FIELDS } = constants.cookies.bannerTextOverride
  return {
    title: getOverride(TEXT_FIELDS.BANNER_TITLE),
    description: getOverride(TEXT_FIELDS.BANNER_DESCRIPTION),
    manage: getOverride(TEXT_FIELDS.BUTTON_MANAGE_COOKIES),
    reject: getOverride(TEXT_FIELDS.BUTTON_REJECT),
    accept: getOverride(TEXT_FIELDS.BUTTON_ACCEPT_ALL),
    manageMobile: getOverride(TEXT_FIELDS.BUTTON_MANAGE_COOKIES_MOBILE),
    rejectMobile: getOverride(TEXT_FIELDS.BUTTON_REJECT_MOBILE),
    acceptMobile: getOverride(TEXT_FIELDS.BUTTON_ACCEPT_ALL_MOBILE),
    privacyPortal: getOverride(TEXT_FIELDS.PRIVACY_PORTAL_LINK),
  }
}

export default { getBannerLevel2Overrides, getBannerOverrides }
